import i18n from '@/settings/i18n';
import Notice from './Notice';
import { BUSINESS_EMAIL } from './constants';

const t = i18n.init('business');

/** The business account couldn't be set up in Stripe. */
const ErrorState = () => (
  <Notice>
    {t`We couldn't set up your business account.`}{' '}
    {t`Please try again, and if the problem persists, contact us at`}{' '}
    <a href={`mailto:${BUSINESS_EMAIL}`} className="underline">
      {BUSINESS_EMAIL}
    </a>
    .
  </Notice>
);

export default ErrorState;
